import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { KupariInputErrorModule } from '../kupari-input-error/kupari-input-error.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { KupariMultiBoxInputComponent } from './kupari-multi-box-input.component';

@NgModule({
  declarations: [
    KupariMultiBoxInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    KupariInputErrorModule,
    TooltipModule.forRoot(),
  ],
  exports: [
    KupariMultiBoxInputComponent
  ]
})
export class KupariMultiBoxInputModule { }
